
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteGroupRepositoryInterface, { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';
import { Website } from '@/services/Website/interfaces';
import { UserInterface, UserRepoInterface } from '@/services/Users/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
  ],
})
export default class TerminateGroupDialog extends Vue {
  @Prop() group!: WebsiteGroup;

  @Prop() mainWebsite!: Website;

  public confirmation = "";

  public visible: boolean = true;

  public loading: boolean = true;

  public async created(): Promise<void> {
    this.loading = false
  }

  public get valid(): boolean {
    return this.confirmation === this.mainWebsite?.domain;
  }

  public async terminate(): Promise<void> {
    this.$emit('terminateGroup');

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');

    this.visible = false;
    this.loading = true;
  }
}
